import { useEffect, useMemo } from 'react';
import { Switch, Route } from 'react-router-dom';

import LoginPage from './LoginPage';
import { Badge } from '../../components';
import Routes, { getRoutes } from '../Routes';
import Layout, { Menu, UserBar } from '../Layout';
import { useAppContext, useAuth } from '../../shared';

const Content = () => {
  const { loading, meta, title } = useAppContext();
  const { isLoading, isAuthenticated, isAuthorized, user, startLogin } =
    useAuth();
  const routes = useMemo(() => getRoutes(meta), [meta]);

  useEffect(
    () => {
      if (loading || isLoading) return;

      const failed = !isAuthenticated || !isAuthorized || !user;
      failed && startLogin?.();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, isLoading, isAuthenticated, isAuthorized, user]
  );

  if (loading || isLoading) return null;

  const menuElement = <Menu items={routes} />;
  const titleElement = !!title && (
    <header className="min-w-[20rem] basis-1/2 grow-0 shrink border-b border-active">
      <div className="font-medium text-title flex flex-row items-center justify-start gap-x-sm h-full">
        {typeof title === 'string' && <Badge text={title || ''} shrink />}
        <div
          className="truncate"
          title={typeof title === 'string' ? title : ''}
        >
          {title}
        </div>
      </div>
    </header>
  );
  const userElement = <UserBar />;

  return (
    <Switch>
      <Route path="/login" exact>
        <LoginPage />
      </Route>
      {isAuthorized && (
        <Route path="*">
          <Layout menu={menuElement} title={titleElement} user={userElement}>
            <Routes routes={routes} />
          </Layout>
        </Route>
      )}
    </Switch>
  );
};

export default Content;
